import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function ClientBrief() {
  return (
    <section className="client__brief p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={10} className="m-auto text-center">
            <h2 style={{ color: "#000" }}>
              Client <span style={{ color: "#F15D20" }}>Brief</span>
            </h2>
            <p>
              Select Dealer Service offers a complete partnership for their
              Dealer clients. They help their clients generate incremental
              income and offer exemplary services, support, and training.
            </p>
            <h2 style={{ color: "#717783" }}>Mission</h2>
            <div className="mission_boxes">
              <div className="mission_box">
                YEAR - <span style={{ color: "#F15D20" }}> 2019</span>
              </div>
              <div className="mission_box">
                ROLE - <span style={{ color: "#F15D20" }}> UI/UX DESIGN</span>
              </div>
              <div className="mission_box">
                TYPE -
                <span style={{ color: "#F15D20" }}> WEBSITE DEVELOPMENT</span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ClientBrief;
